export default {
  title01: "हालको मौसम",
  title02: "२४ घण्टा",
  title03: "१०-दिने मौसम पूर्वानुमान हेर्नुहोस्",
  title04: "AQI",
  title05: "सबै जानकारी हेर्नुहोस्",
  title06: "सूर्योदय र सूर्यास्त",
  title07: "चन्द्रमाको चरण",
  title08: "अर्को पूर्णिमा",
  title09: "अर्को औंसी",
  title10: "दिन",
  title11: "रात",
  title12: "सूर्योदय",
  title13: "सूर्यास्त",
  title14: "चन्द्रोदय",
  title15: "चन्द्रास्त",
  title16: "स्रोत",
  title17: "सुरु",
  title18: "अन्त्य",
  title19: "हालको स्थान प्रयोग गर्नुहोस्",
  title20: "शहर खोज्नुहोस्",
  title21: "महसुस हुने तापक्रम",
  title22: "महसुस हुने तापक्रम (छायाँ)",
  title23: "अहिले",
  title24: "आज",
  title25: "आइत",
  title26: "सोम",
  title27: "मंगल",
  title28: "बुध",
  title29: "बिही",
  title30: "शुक्र",
  title31: "शनि",
  title32: "लोड हुँदैछ...",
  title33: "अहिले",
  title34: "घण्टैपिच्छे",
  title35: "दैनिक",
  title36: "सूर्य र चन्द्रमा",
  title37: "हावाको गुणस्तर",
  title38: "सम्पर्क गर्नुहोस् : xlf550402@gmail.com",
  title39: "गोपनीयता नीति",
  title40: "प्रतिलिपि अधिकार © comfortweather.com 2020 - 2024. सर्वाधिकार सुरक्षित।",
  title41: "डाटा प्रदान गरिएको [LOGO] द्वारा",
  title42: "उच्च",
  title43: "न्यून",
  title44: "स्वीकार गर्नुहोस्",
  title45:
    "ComfortWeather प्रयोग गर्नुभएकोमा धन्यवाद! तपाईंको कानुनी अधिकार र हितहरूको राम्रो सुरक्षा गर्न, कृपया प्रयोग गर्नु अघि “Privacy Policy” ध्यानपूर्वक पढ्नुहोस्।",
  title46: "",
  title47: "",
  title48: "",
  title49: "सम्पर्क गर्नुहोस् : xyjph123@gmail.com",
  title50: "प्रतिलिपि अधिकार © 24hweather.com 2020 - 2026. सर्वाधिकार सुरक्षित।",
  title51: "24hweather प्रयोग गर्नुभएकोमा धन्यवाद! तपाईंको कानुनी अधिकार र हितहरूको राम्रो सुरक्षा गर्न, कृपया",
  title52: "तपाईंको स्थान परिवर्तन भएको छ। के तपाईं यसलाई अद्यावधिक गर्न चाहनुहुन्छ?",
  title53: "पुष्टि गर्नुहोस्",
  title54: "रद्द गर्नुहोस्",
  title55: "फिर्ता",
  title56: "समाचार",
  title57: "मौसम अद्यावधिक हुँदैछ...",
  title58: "मौसम अद्यावधिक भयो",
  title59: "सबै हेर्नुहोस्",
  title61: "हिजो",
  title62: "भोलि",
  title63: "",
  title64: "आजको विवरण",
  title65: "पूर्वनिर्धारित शहर",

  title66: "जीवनशैली सूचकहरू",
  title67: "जीवनशैली सूचकहरू",
  title68: "Next 7 Days Rahu Kaal Timings for",
  title69: "To",
  title70: "to",
  title71: "हावाको गुणस्तर सूचकांक",

  title102: "Hard to dry",
  title103: "Slow drying",
  title104: "Dries well",
  title105: "Quick drying",
  title106: "Very fast drying",

  title107: "Not suitable",
  title108: "Modest experience",
  title109: "Good for water fun",
  title110: "Very suitable",
  title111: "Perfect conditions",

  title112: "Supportive to health",
  title113: "Neutral conditions",
  title114: "Slightly higher risk",
  title115: "High risk",
  title116: "Very high risk",

  title117: "Not suitable",
  title118: "Somewhat suitable",
  title119: "Good for outdoors",
  title120: "Very suitable",
  title121: "Excellent conditions",

  title122: "Very dry conditions",
  title123: "Likely dry",
  title124: "Slightly dry",
  title125: "Not likely dry",
  title126: "Very unlikely dry",

  title127: "Not recommended",
  title128: "Acceptable",
  title129: "Good day",
  title130: "Very good conditions",
  title131: "Ideal conditions",
};
